import React from 'react';
import './styles.css';





export const DescubridoresTituloEncabezado = () => {


  return (
    <>


        <div className='DescubridoresTituloEncabezado-Principal-Container'>

                <div className='DescubridoresTituloEncabezado-subContainer'>

                        <div className='DescubridoresTituloEncabezado-titulo'/>

                        <div className='DescubridoresTituloEncabezado-imagen'/>
                        
                </div>
        </div>

        
    </>
  )
}
